module.exports = __webpack_public_path__ + "images/emoji/pray.9730f9ed49e5b47533cf.png";